import React from 'react';

import './styles.scss';

const SingleValuePlayerStat = ({title, value, className}) => {
    return (
        <div className={`single-value-player-stat ${className}`}>
            <div>{title}</div>
            <div className="single-value-player-stat--value">{value}</div>
        </div>
    );
};

export default SingleValuePlayerStat;